// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Returns a human-readable string for a file size in bytes.
 *
 * @param size - The file size in bytes.
 */
export function formatFileSize(size: number): string {
  if (size < 1024) return `${size.toLocaleString()} B`;
  const kb = size / 1024;
  if (kb < 1024) return `${Math.round(kb).toLocaleString()} KB`;
  const mb = kb / 1024;
  if (mb < 1024) return `${Math.round(mb).toLocaleString()} MB`;
  const gb = mb / 1024;
  return `${Math.round(gb).toLocaleString()} GB`;
}
